import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import '../../scss/main.scss';
import Admin from './components/Admin.jsx';
import Competitions from './contexts/Competitions';

ReactDOM.render(
  <Competitions.Provider>
    <Admin />
  </Competitions.Provider>,
  document.getElementById('root'),
);
